"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus["ACTIVE"] = "ACTIVE";
    CompanyStatus["ARCHIVED"] = "ARCHIVED";
    CompanyStatus["Active"] = "ACTIVE";
    CompanyStatus["Archived"] = "ARCHIVED";
})(CompanyStatus || (exports.CompanyStatus = CompanyStatus = {}));
